import React from "react";
import ChartCard from "./ChartCard";
import Histogram from "../charts/Histogram";

export default class TopCustomerDistributionCard extends React.Component{
    render(){
        return (
            <ChartCard title="Top customers">
                <Histogram resource="top-customer-distribution" />
            </ChartCard>
        )
    }
}